var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgLockIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.96 10.6731H6.44C5.64471 10.6731 5 11.293 5 12.0577V20.3654C5 21.1301 5.64471 21.75 6.44 21.75H17.96C18.7553 21.75 19.4 21.1301 19.4 20.3654V12.0577C19.4 11.293 18.7553 10.6731 17.96 10.6731Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2401 10.6731V8.59615C17.2401 7.31087 16.7091 6.07824 15.7639 5.16941C14.8187 4.26058 13.5368 3.75 12.2001 3.75C10.8634 3.75 9.58143 4.26058 8.63625 5.16941C7.69106 6.07824 7.16006 7.31087 7.16006 8.59615V10.6731",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.2 16.9038C12.5977 16.9038 12.92 16.5939 12.92 16.2115C12.92 15.8292 12.5977 15.5192 12.2 15.5192C11.8024 15.5192 11.48 15.8292 11.48 16.2115C11.48 16.5939 11.8024 16.9038 12.2 16.9038Z",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgLockIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/LockIcon.6b37148b.svg";
export { ForwardRef as ReactComponent };